import { Container } from 'react-bootstrap';
import { SpinnerModal } from '../SpinnerModal/SpinnerModal';
import { connect } from 'react-redux'
import { useAppSelector } from '../../app/hooks';
import { GlobalErrorAlert } from '../GloableErrorAlert/GlobalErrorAlert';
import { useMemo } from "react";

export const Layout = (props: any) => {
    
  const healthErrorMessage = useAppSelector(state => state.health.errorMessage);
  const profileErrorMessage = useAppSelector(state => state.profile.errorMessage);
  const customersErrorMessage = useAppSelector(state => state.customers.errorMessage);
  const noteErrorMessage = useAppSelector(state => state.note.errorMessage);
  const fileUploadErrorMessage = useAppSelector(state => state.note.fileUploadErrorMessage);
    
  const loading = useAppSelector(state =>
    state.health.status === 'loading' ||
    state.profile.status === 'loading' ||
    state.customers.status == 'loading' || 
    state.note.status == 'loading' ||
    state.note.fileUploadStatus == 'loading');
      

  const loadingFailed = useAppSelector(state =>
    state.health.status === 'failed' ||
    state.profile.status === 'failed' ||
    state.customers.status == 'failed' ||
    state.customers.customerLookupStatus == 'failed' ||
    state.note.tagsLookupStatus == 'failed' ||
    state.note.status == 'failed' ||
    state.note.fileUploadStatus == 'failed');

    const errorMessage = useMemo(() => [
        healthErrorMessage,
        profileErrorMessage,
        customersErrorMessage,
        noteErrorMessage,
        fileUploadErrorMessage
    ], [
        healthErrorMessage,
        profileErrorMessage,
        customersErrorMessage,
        noteErrorMessage,
        fileUploadErrorMessage
    ]);

  return (
    <Container fluid>
      {loadingFailed &&
      <GlobalErrorAlert errorMessage = {errorMessage}/>}
      <SpinnerModal show={loading}/>
      {props.children}
     </Container>
  );
};

export default connect()(Layout);
